import { ContactButtons, RefillPill, Tags } from "./CrmBits";
import { fdate, inr } from "./crmUtil";

export const ClientTable = ({ rows, onView }) => (
  <div className="overflow-x-auto rounded-xl border bg-white" data-testid="crm-table-view">
    <table className="w-full min-w-[760px] text-sm">
      <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
        <tr>{["Client", "Tags", "Contact", "Orders", "Spent", "Last order", "Refill", ""].map((h) => <th key={h} className="px-3 py-2 font-semibold">{h}</th>)}</tr>
      </thead>
      <tbody>{rows.map((c) => (
        <tr key={c.key} className="border-t transition-colors hover:bg-teal-50/40" data-testid={`crm-table-row-${c.key}`}>
          <td className="px-3 py-2"><b>{c.name}</b><div className="max-w-[220px] truncate text-xs text-slate-400">{c.addresses[0] || "No address"}</div></td>
          <td className="px-3 py-2"><div className="flex flex-wrap gap-1"><Tags c={c} /></div></td>
          <td className="px-3 py-2"><ContactButtons c={c} compact /></td>
          <td className="px-3 py-2">{c.orders}</td>
          <td className="px-3 py-2 font-semibold">{inr(c.spent)}</td>
          <td className="px-3 py-2 text-slate-600">{fdate(c.last)}</td>
          <td className="px-3 py-2"><RefillPill r={c.refill} /></td>
          <td className="px-3 py-2"><button onClick={() => onView(c.key)} className="rounded-md border px-2 py-1 text-xs font-semibold hover:bg-slate-50" data-testid={`crm-table-action-view-${c.key}`}>Open</button></td>
        </tr>))}</tbody>
    </table>
    {!rows.length && <p className="p-6 text-center text-sm text-slate-400">No clients match.</p>}
  </div>
);
